/* eslint-disable no-console */
import { Box, Typography, CircularProgress } from "@mui/material";
import { useMemo } from "react";
import DistinctValuesDnD from "../components/distinct-values/distinct-values-dnd";
import { FieldInfoCard } from "../components/field-info";
import { useStepper } from "../../../context/stepper-provider";
import { useDataCleaningContext } from "../context/data-cleaning-context";
import useCleaningData from "../hooks/use-cleaning-data";
import { formatDataType } from "../utils/data-type-formatter";

// Main component content that uses the stepper context
const CleansingData = () => {
  const { isStepCompleted } = useStepper();
  const { selection } = useDataCleaningContext();
  const { getFilteredFields, isLoading, error } = useCleaningData();

  const hasSelectedEntity = isStepCompleted(1);
  const hasSelectedField = isStepCompleted(2);

  // Get the selected field data from API
  const selectedFieldData = useMemo(() => {
    if (
      !hasSelectedField ||
      !selection.selectedFieldId ||
      selection.selectedClientIds.length === 0
    ) {
      return null;
    }

    const allFields = getFilteredFields(selection.selectedClientIds);
    return allFields.find((field) => field.id === selection.selectedFieldId);
  }, [
    hasSelectedField,
    selection.selectedFieldId,
    selection.selectedClientIds,
    getFilteredFields,
  ]);

  if (!hasSelectedEntity || !hasSelectedField) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "500px",
          p: 4,
        }}
      >
        <Typography variant="body1" color="text.secondary">
          Data to be clean will be available here after the selection of a
          client, entity and field
        </Typography>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "500px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error || !selectedFieldData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "500px",
          p: 4,
        }}
      >
        <Typography variant="body1" color={error ? "error" : "text.secondary"}>
          {error
            ? "Error loading field data. Please try refreshing."
            : "Please select a field. Data will be displayed here once a field is selected."}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <FieldInfoCard
        title={selectedFieldData.name}
        type={
          formatDataType(
            selectedFieldData.templateInformation.dataType.description,
            selectedFieldData.templateInformation.maxLength,
          ) || "-"
        }
        template={selectedFieldData.templateInformation.description || "-"}
        records={selectedFieldData.count}
      />
      <Box mt={2}>
        <DistinctValuesDnD
          values={[
            { id: "1", value: "2024-01-01" },
            { id: "2", value: "2024-01-02" },
            { id: "3", value: "2024-01-03" },
          ]}
          labelOptions={[
            { id: "cat", label: "HIT CAT" },
            { id: "dog", label: "HIT DOG" },
          ]}
        />
      </Box>
    </Box>
  );
};

export default CleansingData;
